// extracted by mini-css-extract-plugin
module.exports = {"category-card":"CategoryCard_category-card__zoQEE","icon-bg":"CategoryCard_icon-bg__xrrch","text":"CategoryCard_text__i95mi"};